import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d98faa36")

_pushScopeId("data-v-d98faa36")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 営業時間登録 ")
const _hoisted_2 = { class: "calendar-day-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_hour_tag = _resolveComponent("hour-tag")
  const _component_calendar = _resolveComponent("calendar")
  const _component_delete_business_hour = _resolveComponent("delete-business-hour")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("div", null, [
            _createVNode("h2", null, [
              _createVNode(_component_back_button),
              _hoisted_1
            ])
          ]),
          _createVNode("div", null, _toDisplayString(_ctx.name) + "の営業時間", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_calendar, {
        disableAfterToday: false,
        onAdd: _ctx.onAdd
      }, _createSlots({ _: 2 }, [
        _renderList(_ctx.dayList, (day, dayIndex) => {
          return {
            name: `day_${day.day}`,
            fn: _withId(() => [
              _createVNode("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(day.hourList, (hour, hourIndex) => {
                  return (_openBlock(), _createBlock(_component_hour_tag, {
                    class: "calendar-day-content-tag",
                    key: 'business'+dayIndex+'-'+hourIndex,
                    focused: hour.businessHour.id === _ctx.mouseOverId,
                    close: !!hour.temporaryClose,
                    "close-day": hour.businessHour.intervalType !== 'once' && day.closeDay,
                    onClick: ($event: any) => (_ctx.onDelete(dayIndex, hourIndex)),
                    onMouseenter: ($event: any) => (_ctx.mouseOverId=hour.businessHour.id),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mouseOverId=''))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", null, _toDisplayString(_ctx.businessHourIntervalString(hour.businessHour)), 1)
                    ]),
                    content: _withId(() => [
                      _createVNode("div", null, _toDisplayString(`${hour.businessHour.startTime}-${hour.businessHour.endTime}`), 1)
                    ]),
                    _: 2
                  }, 1032, ["focused", "close", "close-day", "onClick", "onMouseenter"]))
                }), 128))
              ])
            ])
          }
        })
      ]), 1032, ["onAdd"]),
      (_ctx.selectedHour)
        ? (_openBlock(), _createBlock(_component_delete_business_hour, {
            key: 0,
            ref: "deleteRef",
            once: _ctx.selectedHour.businessHour.intervalType==='once',
            close: !!_ctx.selectedHour.temporaryClose,
            closeDay: _ctx.selectedHour.closeDay,
            onDelete: _ctx.onDeleteAll,
            onCreateTemporaryClose: _ctx.onCreateTemporaryClose,
            onDeleteTemporaryClose: _ctx.onDeleteTemporaryClose
          }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.formatYMD(_ctx.selectedHour.date)) + " " + _toDisplayString(_ctx.businessHourIntervalString(_ctx.selectedHour.businessHour)) + " " + _toDisplayString(_ctx.selectedHour.businessHour.startTime) + "-" + _toDisplayString(_ctx.selectedHour.businessHour.endTime), 1)
            ]),
            _: 1
          }, 8, ["once", "close", "closeDay", "onDelete", "onCreateTemporaryClose", "onDeleteTemporaryClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})